export enum PageEndpointEnum {
  TRADE = "/trade",
  PORTFOLIO = "/portfolio",
  REQUESTS = "/mm/requests",
  MMPORTFOLIO = "/mm/portfolio"
}
